module.exports = ".container-fluid {\n  padding-left: 0;\n  padding-right: 0; }\n"